import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SZ2424Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SZ2424IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4H22V19H2V4Z"
        fill="#3D58DB"
      />
      <path
        d="M2 6.75H1V7.75V15.25V16.25H2H22H23V15.25V7.75V6.75H22H2Z"
        fill="#C51918"
        stroke="#FFD018"
        strokeWidth="2"
      />
      <path
        d="M6.46827 9.83189C6.3933 9.83189 6.33252 9.66239 6.33252 9.4533C6.33252 9.24421 6.3933 9.07471 6.46827 9.07471H17.35C17.425 9.07471 17.4857 9.24421 17.4857 9.4533C17.4857 9.66239 17.425 9.83189 17.35 9.83189H6.46827Z"
        fill="#FFD018"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0596 9.37643L17.6915 8.57031L18.8096 9.37643L17.6915 10.2038L17.0596 9.37643Z"
        fill="#F7FCFF"
      />
      <path
        d="M6.46827 12.3319C6.3933 12.3319 6.33252 12.1624 6.33252 11.9533C6.33252 11.7442 6.3933 11.5747 6.46827 11.5747H17.35C17.425 11.5747 17.4857 11.7442 17.4857 11.9533C17.4857 12.1624 17.425 12.3319 17.35 12.3319H6.46827Z"
        fill="#FFD018"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0596 11.8764L17.6915 11.0703L18.8096 11.8764L17.6915 12.7038L17.0596 11.8764Z"
        fill="#F7FCFF"
      />
      <path
        d="M4.7157 13.8885C4.61518 13.8885 4.53369 13.6961 4.53369 13.4587C4.53369 13.2213 4.61518 13.0288 4.7157 13.0288H19.3058C19.4063 13.0288 19.4878 13.2213 19.4878 13.4587C19.4878 13.6961 19.4063 13.8885 19.3058 13.8885H4.7157Z"
        fill="#FFD018"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.51074 11.5329C7.51074 11.5329 9.28658 7.79541 11.8265 7.79541C14.3665 7.79541 16.202 11.5329 16.202 11.5329C16.202 11.5329 13.9607 15.2213 11.8564 15.2213C9.75209 15.2213 7.51074 11.5329 7.51074 11.5329Z"
        fill="#F7FCFF"
      />
      <mask
        id="mask0_1813_848"
        mask-type="luminance"
        maskUnits="userSpaceOnUse"
        x="7"
        y="7"
        width="10"
        height="9"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.51074 11.5329C7.51074 11.5329 9.28658 7.79541 11.8265 7.79541C14.3665 7.79541 16.202 11.5329 16.202 11.5329C16.202 11.5329 13.9607 15.2213 11.8564 15.2213C9.75209 15.2213 7.51074 11.5329 7.51074 11.5329Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1813_848)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9526 7.55005C11.9526 7.55005 11.373 8.25393 11.5662 8.92512C11.7594 9.59632 12.2095 9.52543 12.2095 10.1165C12.2095 10.7076 12.0015 11.3105 12.2095 11.3105C12.4174 11.3105 12.4895 11.7184 12.2994 11.9949C12.1094 12.2714 11.9413 12.28 11.9526 12.7301C11.9638 13.1801 12.9476 13.6219 12.471 13.6219C11.9945 13.6219 11.3664 14.0845 11.5662 14.0845C11.766 14.0845 12.8116 14.4449 12.8116 14.9178C12.8116 15.3908 12.8116 15.7693 12.8116 15.7693H7.35693V7.55005H11.9526Z"
          fill="#272727"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1875 10.2019H9.91602V11.3077H10.1875V10.2019ZM9.38689 10.2019H9.1154V11.3077H9.38689V10.2019ZM9.51562 10.2019H9.78712V11.3077H9.51562V10.2019ZM10.5879 10.2019H10.3164V11.3077H10.5879V10.2019ZM10.717 10.2019H10.9885V11.3077H10.717V10.2019ZM11.3888 10.2019H11.1174V11.3077H11.3888V10.2019ZM9.11523 11.7884H9.38673V12.8942H9.11523V11.7884ZM10.1875 11.7884H9.91602V12.8942H10.1875V11.7884ZM9.51562 11.7884H9.78712V12.8942H9.51562V11.7884ZM10.5879 11.7884H10.3164V12.8942H10.5879V11.7884ZM10.717 11.7884H10.9885V12.8941H10.717V11.7884ZM11.3888 11.7884H11.1174V12.8941H11.3888V11.7884Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4116 10.2019H13.1401V11.3077H13.4116V10.2019ZM12.6108 10.2019H12.3394V11.3077H12.6108V10.2019ZM12.7397 10.2019H13.0112V11.3077H12.7397V10.2019ZM13.812 10.2019H13.5405V11.3077H13.812V10.2019ZM13.9413 10.2019H14.2128V11.3077H13.9413V10.2019ZM14.6132 10.2019H14.3417V11.3077H14.6132V10.2019ZM12.3394 11.7884H12.6108V12.8942H12.3394V11.7884ZM13.4116 11.7884H13.1401V12.8942H13.4116V11.7884ZM12.7397 11.7884H13.0112V12.8942H12.7397V11.7884ZM13.812 11.7884H13.5405V12.8942H13.812V11.7884ZM13.9413 11.7884H14.2128V12.8942H13.9413V11.7884ZM14.6132 11.7884H14.3417V12.8942H14.6132V11.7884Z"
          fill="#272727"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2693 8.41966C9.88894 8.53748 9.71491 9.53487 9.75742 9.77595C9.79993 10.017 9.92896 9.7457 9.92896 9.7457C9.92896 9.7457 10.1921 10.3176 10.2192 10.4715C10.2464 10.6254 10.385 10.2389 10.385 10.2389C10.385 10.2389 10.8414 10.5534 10.9032 10.9037C10.965 11.2541 11.0579 10.5028 11.0579 10.5028L11.1613 10.4846L11.0959 10.1136L11.2931 10.2822L11.2322 9.93715C11.2322 9.93715 11.3807 10.1312 11.3431 9.91761C11.3054 9.70399 11.2844 9.58473 11.2844 9.58473L11.2329 9.29276L11.4281 9.25835C11.4281 9.25835 10.6496 8.30183 10.2693 8.41966Z"
          fill="#3D58DB"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.305 12.5598C17.91 12.6098 17.5654 13.5618 17.5654 13.8066C17.5654 14.0514 17.7396 13.8066 17.7396 13.8066C17.7396 13.8066 17.8995 14.4156 17.8995 14.5718C17.8995 14.7281 18.103 14.3715 18.103 14.3715C18.103 14.3715 18.498 14.7605 18.498 15.1163C18.498 15.4721 18.7199 14.7483 18.7199 14.7483H18.8249V14.3715L18.9898 14.5718V14.2215C18.9898 14.2215 19.1024 14.4384 19.1024 14.2215C19.1024 14.0046 19.1024 13.8835 19.1024 13.8835V13.587H19.3006C19.3006 13.587 18.7 12.5098 18.305 12.5598Z"
        fill="#3D58DB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.49528 12.4158C5.89028 12.4658 6.23486 13.4178 6.23486 13.6626C6.23486 13.9074 6.06067 13.6626 6.06067 13.6626C6.06067 13.6626 5.90083 14.2715 5.90083 14.4278C5.90083 14.584 5.69725 14.2275 5.69725 14.2275C5.69725 14.2275 5.30233 14.6164 5.30233 14.9722C5.30233 15.328 5.08035 14.6042 5.08035 14.6042H4.97536V14.2275L4.81045 14.4278V14.0775C4.81045 14.0775 4.6979 14.2944 4.6979 14.0775C4.6979 13.8605 4.6979 13.7394 4.6979 13.7394V13.443H4.49972C4.49972 13.443 5.10029 12.3658 5.49528 12.4158Z"
        fill="#3D58DB"
      />
    </svg>
  );
};

export default SZ2424Icon;
